import { Stack, useTheme } from '@mui/material';

import { ArrowLeft, ArrowRight } from '../../icons';
import { gray300Color } from '../tokenColorTemporary';

export interface DottedPaginationProps {
  currentPage?: number;
  totalPage?: number;
  onPrev?: VoidFunction;
  onNext?: VoidFunction;
  DotColor?: string;
}

const EliceDottedPagination = (props: DottedPaginationProps) => {
  const { currentPage = 1, totalPage = 1, onNext, onPrev, DotColor } = props;
  const isPrevAble = currentPage > 1;
  const isNextAble = currentPage < totalPage;
  const theme = useTheme();
  const dotColor = DotColor || theme.palette.primary.main;
  if (totalPage > 10 || currentPage > 10) return 'Total page is at most 10';

  return (
    <Stack direction="row" gap="1rem">
      <ArrowLeft
        size={24}
        color={isPrevAble ? dotColor : gray300Color}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          if (onPrev && isPrevAble) {
            onPrev();
          }
        }}
      />
      <Stack direction="row" gap="0.375rem" alignItems="center">
        {Array.from({ length: totalPage }, i => i).map((_, index: number) => {
          return (
            <Stack
              key={index}
              borderRadius="0.3rem"
              height="0.75rem"
              width="0.75rem"
              bgcolor={
                currentPage === index + 1
                  ? dotColor
                  : gray300Color
              }
            ></Stack>
          );
        })}
      </Stack>
      <ArrowRight
        size={24}
        color={isNextAble ? dotColor : gray300Color}
        style={{ cursor: 'pointer' }}
        onClick={() => {
          if (onNext && isNextAble) {
            onNext();
          }
        }}
      />
    </Stack>
  );
};

export default EliceDottedPagination;
